module.exports = __webpack_public_path__ + "media/mypage/images/icons/arrow_right_y-6b8323361029876d8aafa0929be62000.png";